module.exports = __webpack_public_path__ + "assets/img/expansion.75c36bd2.svg";